import React, {useState, useEffect, useRef} from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import ptLocale from '@fullcalendar/core/locales/pt-br';
import ApiService from "../util/ApiService";

import './assets/css/FullCalendar.css';
import DutyDetailModal from "../dashboard/calender/dutyDetailModal";
import PlantaoModal from "../dashboard/calender/plantaoModal";
import PlantaoRepostModal from "../dashboard/calender/plantaoRepostModal";
import UsersSearch from "../dashboard/calender/UsersSearch";
import HospitalSearch from "../hospital/HospitalSearch";
import Select from "react-select";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import {format} from 'date-fns';
import LoadingScreen from "../util/LoadingScreen";
import AuthService from "../util/AuthService";

const FullCalendarDuty = (props) => {
    document.title = "Plantão - Calendário | Plantão Rápido";

    const user = AuthService.getUserData();
    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [duty, setDuty] = useState([]);
    const [duties, setDuties] = useState([]);
    const [selectedEventDetails, setSelectedEventDetails] = useState(null);
    const refUserSearch = useRef(null);
    const refHospitalSearch = useRef(null);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [showScaleModal, setShowScaleModal] = useState(false);

    const [loadingPage, setLoadingPage] = useState(false);
    const [userOptions, setUserOptions] = useState(null);
    const [hospitalOptions, setHospitalOptions] = useState(null);
    const [arraScale, setArrayScale] = useState([]);
    const [scale, setScale] = useState([]);
    const [currentDate, setCurrentDate] = useState(
        new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-')
    );


    const [showEventModal, setShowEventModal] = useState(false);
    const [showPlantaoModal, setShowPlantaoModal] = useState(false);
    const [showPlantaoRepostModal, setShowPlantaoRepostModal] = useState(false);

    const [filters, setFilters] = useState({
        user_id: "",
        hospital: "",
        duty_scale_day_wee_id: "",
        order_month: "",
        department_id: "",
    });

    const calendarRef = useRef(null);
    const lastFetchedRange = useRef({startStr: '', endStr: ''}); // Armazena o intervalo anterior





    const formatTime = (datetime) => {
        const date = new Date(datetime);
        return date.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
    };


    const getCurrentDateRange = (calendarApi) => {
        const view = calendarApi.view;
        return {
            startStr: view.activeStart.toISOString().split('T')[0],
            endStr: view.activeEnd.toISOString().split('T')[0],
        };
    };

    const getMonthRangeFromCalendar = () => {
        const calendarApi = calendarRef.current?.getApi();
        if (!calendarApi) return null;

        const currentDate = calendarApi.getDate(); // Data central da view atual
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth(); // de 0 a 11

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0); // Último dia do mês

        const format = (date) => date.toISOString().split('T')[0];

        return {
            startStr: format(start),
            endStr: format(end),
        };
    };

    const fetchEvents = async (datestart, dateend, updatedFilters = null) => {

        try {

            if(updatedFilters == null){
                updatedFilters = filters;
            }

            setLoadingPage(true);

            const params = {
                datestart: datestart,
                dateend: dateend,
                hospital: updatedFilters.hospital_id,
                user: updatedFilters.user_id,
                department: updatedFilters.department_id,
                per_page: 2000
            };

            if (user.users_type_id === 1) {
                params.logged_in_user = true;
            }


            const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}duty/duty-record`,
                params,
                true
            );

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);

            if (data) {
                setDuties(data);

                const eventData = data.map((event) => {
                    const hasUser = !!event.accept_user;
                    return {
                        title: `${formatTime(event.date_time)} - ${formatTime(event.date_time_end)}${
                            event.accept_user ? `\n\n${event.accept_user.name}` : ''
                        }`,
                        start: event.date_time,
                        end: event.date_time_end,
                        id: event?.id,
                        extendedProps: {...event},
                        classNames: hasUser ? 'event-with-user' : 'event-without-user',
                    };
                });
                setEvents(eventData || []);
            }

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };

    const fetchEventsIfNeeded = (startStr, endStr) => {
        if (startStr !== lastFetchedRange.current.startStr || endStr !== lastFetchedRange.current.endStr) {
            lastFetchedRange.current = {startStr, endStr};
            fetchEvents(startStr, endStr);
        }
    };

    const handleDatesSet = () => {
        if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            const {startStr, endStr} = getCurrentDateRange(calendarApi);
            if (startStr && endStr) {
                fetchEventsIfNeeded(startStr, endStr); // Chama apenas se o intervalo mudou
            }

        }
    };

    const renderEventContent = (arg) => {
        const {event} = arg;
        const startTime = dayjs(event.start).format("HH:mm");
        const endTime = dayjs(event.end).format("HH:mm");
        const name = event.extendedProps?.accept_user?.name;

        const truncate = (str, max) => {
            return str && str.length > max ? str.slice(0, max - 3) + "..." : str;
        };

        return (
            <div style={{fontSize: '11px', lineHeight: '1.2'}}>
                <div>{`${startTime} - ${endTime}`}</div>
                {name && <div><strong>{truncate(name, 24)}</strong></div>}
            </div>
        );
    };


    const handleEventClick = (clickInfo) => {
        setSelectedEventDetails(clickInfo.event.extendedProps);
        setShowEventModal(true);
    };


    const handlePlantaoModalClose = (save = false) => {
        setShowPlantaoModal(false);
        console.log('Fechar');
        if (save) {
            console.log('buscar');
            if (calendarRef.current) {
                console.log('calendario');
                const calendarApi = calendarRef.current.getApi();
                const {startStr, endStr} = getCurrentDateRange(calendarApi);
                fetchEvents(startStr, endStr); // Atualiza eventos sempre que o filtro muda
            }
        }

    };

    const handlePlantaoRepostModalClose = (save = false) => {
        setShowPlantaoRepostModal(false);
        console.log('Fechar');
        if (save) {
            console.log('buscar');
            if (calendarRef.current) {
                console.log('calendario');
                const calendarApi = calendarRef.current.getApi();
                const {startStr, endStr} = getCurrentDateRange(calendarApi);
                fetchEvents(startStr, endStr); // Atualiza eventos sempre que o filtro muda
            }
        }
    };

    const onUserSelect = (users) => {
        setFilters({...filters, user_id: users?.value || null});
    };


    const getCurrentWeekOfMonth = () => {
        const today = dayjs();
        const startOfMonth = today.startOf("month");
        const weekNumber = Math.ceil(today.date() / 7); // Divide os dias pelo número da semana

        return weekNumber > 5 ? 5 : weekNumber; // Se passar da 5ª semana, mantém como 5
    };

    const handleFilterChange = (key, value) => {

        const updatedFilters = { ...filters, [key]: value };

        setFilters(updatedFilters);

        if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            const { startStr, endStr } = getCurrentDateRange(calendarApi);
            fetchEvents(startStr, endStr, updatedFilters);
        }
    };


    const handleOpen = () => {
        setShowPlantaoModal(true);
        setDuty(null);
    }

    const handleEdit = (scale) => {
        setScale(scale);
        setShowScaleModal(true);
    }

    const onHospitalSelect = (hospital) => {
        setFilters({...filters, hospital_id: hospital?.value || null});
    };

    const handleClearFilters = () => {
        setFilters({
            hospital_id: "",
            user_id: "",
            order_month: "",
            department_id: null,
        });

        if (refUserSearch.current) {
            refUserSearch.current.clearUser();
        }

        if (refHospitalSearch.current) {
            refHospitalSearch.current.clearHospital();
        }
    };


    useEffect(() => {
        fetchDepartment();
        setFilters(prevFilters => ({
            ...prevFilters,
            order_month: prevFilters.order_month || getCurrentWeekOfMonth(),
        }));

    }, []);

    const fetchDepartment = async () => {
        try {
            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}departments/list-department`, {
                all: true,
                status: 'S'
            }, true);

            const {data} = ApiService.handleApiResponse(response);


            const options = data.map((department) => ({
                value: department.id,
                label: department.name,
            }));

            setDepartmentOptions(options);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    const formatDate = (date) => {
        if (!date || !(date instanceof Date)) {
            date = new Date(date); // garante que seja um Date
        }
        return format(date, "yyyy-MM-dd'T'HH:mm");
    };


    const handleEventDrop = async (info) => {
        const updatedEvent = info.event.extendedProps;

        const updatedDuty = {
            id: updatedEvent.id,
            value: parseFloat(updatedEvent.value), // Garante que é número
            hospital_id: updatedEvent.hospital_id,
            department_id: updatedEvent.department_id,
            date_time: formatDate(info.event.start),
            date_time_end: formatDate(info.event.end),
            observation: updatedEvent.observation || "",
            validated_user: updatedEvent.validated_user,
            self_approval: updatedEvent.self_approval,
            specialties: Array.isArray(updatedEvent.specialties)
                ? updatedEvent.specialties.map(s => ({
                    value: typeof s === 'object' ? s.id : s
                }))
                : [],
        };

        try {
            await ApiService.send(
                "put",
                `${process.env.REACT_APP_URL_API}duty/update`,
                updatedDuty,
                true
            );
            Swal.fire({
                toast: true,
                position: 'top-end', // topo à direita
                icon: 'success',
                title: 'Plantão atualizado!',
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
            });

        } catch (error) {
            ApiService.handleApiError(error);
            info.revert();
        }
    };


    const handleDateSelect = (selectInfo) => {
        const start = selectInfo.startStr;

        // Define o duty com data clicada como base
        setDuty({
            date_time: start,
            date_time_end: start, // ou calcule hora fim padrão se quiser
            users_id: null,
            hospital_id: filters.hospital_id || null,
            department_id: filters.department_id || null,
            // você pode adicionar mais campos padrão aqui se quiser
        });

        setShowPlantaoModal(true);
    };


    const handleDetailClose = (save = false) => {
        setShowEventModal(false);

        console.log('Fechar');
        if (save) {
            console.log('buscar');
            if (calendarRef.current) {
                console.log('calendario');
                const calendarApi = calendarRef.current.getApi();
                const {startStr, endStr} = getCurrentDateRange(calendarApi);
                fetchEvents(startStr, endStr); // Atualiza eventos sempre que o filtro muda
            }
        }
    };

    return (

        <>
            {loadingPage && <LoadingScreen/>}
            <div className="col-md-12 col-lg-12 row ">
                    <div className="col-4 form-group">
                        <UsersSearch
                            situation="accepted"
                            buttonAdd={false}
                            onUserSelect={(user) =>
                                handleFilterChange("user_id", user?.value || null)
                            }
                            initialUser={userOptions}
                            initialUserEditable={true}

                        />
                    </div>
                    <div className="col-4 form-group">
                        <HospitalSearch
                            buttonAdd={false}
                            cache={false}
                            validateManager={true}
                            onHospitalSelect={(hospital) =>
                                handleFilterChange("hospital_id", hospital?.value || null)
                            }
                            initialHospital={hospitalOptions}
                        />
                    </div>
                    <div className="col-12 col-lg-2 col-xl-4 col-md-4  form-group">
                        <div className="form-group" style={{position: "relative"}}>
                            <label>Departamento</label>
                            <Select
                                isClearable={true}
                                value={departmentOptions.find(option => option.value === filters.department_id) || null} // Define valor inicial
                                onChange={(selectedOption) =>
                                    handleFilterChange("department_id", selectedOption?.value || null)
                                }
                                options={departmentOptions}
                                placeholder="Selecione"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999
                                    }), // Definindo z-index alto
                                    menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-12 ">
                        <div className="col-md-12 d-flex justify-content-end">

                            <button type="button" className="btn  btn-primary "
                                    onClick={() => handleOpen()}>
                                <i className="ri-add-line align-bottom me-1"></i> Cadastrar
                            </button>
                        </div>
                    </div>



                <FullCalendar
                    ref={calendarRef}
                    eventContent={renderEventContent}
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    headerToolbar={{
                        left: "prev",
                        center: "title",
                        right: "next",
                    }}
                    height="100%"          // ocupa 100% da altura do contêiner pai
                    contentHeight="auto"   // ajusta a altura com base no conteúdo
                    expandRows={true}      // (opcional) garante altura flexível por linha
                    initialView="dayGridMonth"
                    editable={true}
                    selectable={true}
                    selectMirror={true}
                    eventDrop={handleEventDrop}
                    dayMaxEvents={true}
                    events={events}
                    locales={[ptLocale]}
                    eventClick={handleEventClick}
                    datesSet={handleDatesSet}
                    select={handleDateSelect}
                    fixedWeekCount={true}
                    eventClassNames="custom-event"

                />


                {/* Modal de detalhes do evento */}
                {showEventModal && (
                    <DutyDetailModal
                        show={showEventModal}
                        handleClose={handleDetailClose}
                        eventDetails={selectedEventDetails}
                        onRepost={(event) => {
                            setShowEventModal(false);
                            setDuty(event);
                            setShowPlantaoRepostModal(true);
                        }}
                        onEdit={(event) => {
                            setShowEventModal(false);
                            setDuty(event);
                            setShowPlantaoModal(true);
                        }}
                    />
                )}

                {/* Modal de cadastro de plantão */}
                {showPlantaoModal && (
                    <PlantaoModal
                        show={showPlantaoModal}
                        handleClose={handlePlantaoModalClose}
                        duty={duty}
                    />
                )}

                {showPlantaoRepostModal && (
                    <PlantaoRepostModal
                        show={showPlantaoRepostModal}
                        handleClose={handlePlantaoRepostModalClose}
                        duty={duty}
                    />
                )}
            </div>
        </>
    );
};

export default FullCalendarDuty;
